export default class DetailEntity {
  constructor () {
    this.alerts = [];
  }
}

if (Utils.isDebug()) {
  window.DetailEntity = DetailEntity;
}
